const routes = [
    {
        path: "/program/outcome/definition",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "programoutcomedefinition_index"
        }
    }
]

export default routes;
